import { Constants } from ".";
export const obtainAssetLocationOverride = () => {
  var _a, _b, _c;
  // Priority is (i) asset location override in session storage,
  // then (ii) the `data-asset-location` parameter on the `<script>`
  const assetLocationFromSessionStorage = sessionStorage.getItem(Constants.ASSET_LOCATION_OVERRIDE_SESSION_STORAGE_KEY);
  return assetLocationFromSessionStorage || ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.currentScript) === null || _b === void 0 ? void 0 : _b.dataset) === null || _c === void 0 ? void 0 : _c.assetLocation) || false;
};
export const determineCurrentScriptPrefix = () => {
  if (!window.document.currentScript || !document.currentScript.getAttribute("src")) {
    return "";
  }
  const url = new URL(document.currentScript.getAttribute("src"),
  // This is added for relative links (e.g., `/build/md-application.js`)
  // It should be ignored when `src` is a complete URL
  window.location.href);
  const prefixes = url.pathname.split("/").filter(p => p.trim() !== "" && !/.+\.js$/i.test(p));
  const path = prefixes.length > 0 ? `/${prefixes.join("/")}` : "";
  return `${url.protocol}//${url.host}${path}`;
};
export const generateURLRelativeToScript = url => {
  const assetLocation = obtainAssetLocationOverride();
  if (assetLocation) {
    return `${assetLocation}${url}`;
  } else {
    return `${determineCurrentScriptPrefix()}${url}`;
  }
};
export const loadScript = (res, componentName) => {
  let parentElement = document.body;
  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  if (typeof res === "string") {
    script.setAttribute("src", res);
  } else if (typeof res === "object") {
    const {
      src,
      id,
      data,
      parent,
      async
    } = res;
    if (id && document.getElementById(id)) {
      // Already present
      return;
    }
    script.setAttribute("src", src);
    if (data) {
      Object.keys(data).forEach(key => script.dataset[key] = data[key]);
    }
    if (id) {
      script.setAttribute("id", id);
    }
    if (componentName) {
      script.dataset.componentName = componentName;
    }
    if (async) {
      script.setAttribute("async", "");
    }
    if (parent) {
      parentElement = parent;
    }
  } else {
    console.warn(`Invalid script configuration`, res);
    return;
  }
  parentElement.appendChild(script);
  return script;
};
export const loadStyle = function (href) {
  let parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.head;
  const styleElement = document.createElement("link");
  styleElement.setAttribute("rel", "stylesheet");
  styleElement.setAttribute("type", "text/css");
  styleElement.setAttribute("media", "all");
  styleElement.setAttribute("href", href);
  parent.appendChild(styleElement);
  return styleElement;
};
export const adhocStyle = function (rules) {
  let parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.head;
  const styleElement = document.createElement("style");
  styleElement.innerHTML = rules;
  parent.appendChild(styleElement);
  return styleElement;
};
export const appendStyleElement = (source, destination) => {
  if (source.parentNode) {
    adhocStyle(source.innerHTML, destination);
  } else {
    destination.appendChild(source);
  }
};
// export const loadEarlyToken = (
//   pageActionsProvider: PageActionsProvider | undefined
// ) => {
//   if (!pageActionsProvider) {
//     console.warn("[MD-journeys.js] Could not loadEarlyToken w/o a provider");
//     return;
//   }
//   const provider = pageActionsProvider();
//   if (!provider || !provider.tokenProvider) {
//     console.warn(
//       "[MD-journeys.js] Could not loadEarlyToken w/o a token provider"
//     );
//     return;
//   }
//   return pageActionsProvider().tokenProvider();
// };
// export const registerTokenProvider = (
//   pageActionsProvider: PageActionsProvider
// ) => {
//   // An extra wrapper is provided in case the provider isn't available on load
//   (window as any).MD.TOKEN_PROVIDER = () =>
//     pageActionsProvider().tokenProvider();
// };
export const obtainCurrentElementName = () => {
  var _a, _b, _c, _d;
  if (!((_b = (_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.componentName)) {
    return false;
  }
  return (_d = (_c = document.currentScript) === null || _c === void 0 ? void 0 : _c.dataset) === null || _d === void 0 ? void 0 : _d.componentName;
};